import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import RefrencesRender from '../pages/Questionnaire/QuestionnerRenders/RefrencesRender';
import { Container } from '../pages/Questionnaire/styles';
import { LabeledTimer } from '../LabeledTimer';


export default function ReferencesView({ payload, timeLeft, onNext }) {
  const { references, messageBeforeChapter, chapterHasQuestions, chapterIsBreak } = payload;
  const refreshBadgesRef = useRef(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openSkipDialog, setOpenSkipDialog] = useState(false);

  const handleNextClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleConfirm = () => {
    setOpenConfirmDialog(false);
    // Force badge refresh if needed
    if (refreshBadgesRef.current) refreshBadgesRef.current();
    onNext(null, true);
  };

  const handleCancel = () => {
    setOpenConfirmDialog(false);
    setOpenSkipDialog(false);
  };

  return (
    <>
      {Number.isFinite(timeLeft) && (
        <LabeledTimer
          label="זמן עד תחילת הפרק"
          timeSec={timeLeft}
          sx={{
            position: 'absolute',
            top: '24px',
            left: '24px',
            zIndex: 1000,
          }}
        />
      )}

      <div>
        <Container sx={{ mt: 4, mb: 4, px: 2, maxWidth: 800, position: 'relative', minHeight: 400, pt: 2 }}>
          <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
            חומרי עזר
          </Typography>

          <Box sx={{ mb: 4, mt: 4, textAlign: 'center' }}>
            <Typography
              variant="h6"
              sx={{ mb: 2, textAlign: "center" }}
            >
              לפניכם חומרי עזר, עיינו בהם היטב וכשתסיימו עברו לשלב השאלות
            </Typography>
          </Box>

          <Box sx={{ mt: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', pb: 2 }}>
            <Box sx={{ height: 48, mb: 1, display: 'flex', alignItems: 'center' }}>
              {(chapterIsBreak && timeLeft > 0) && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => setOpenSkipDialog(true)}
                >
                  דלג על ההפסקה
                </Button>
              )}
            </Box>

            <Button
              variant="contained"
              color="primary"
              disabled={timeLeft > 0}
              onClick={handleNextClick}
              sx={{ minWidth: 200 }}
            >
              {chapterHasQuestions ? "תחילת הפרק" : "המשך"}
            </Button>
          </Box>
        </Container>

        <div>
          <RefrencesRender
            refrences={references || []}
            receiveRefreshBadgesTrigger={(cb) => {
              refreshBadgesRef.current = cb;
            }}
          />
        </div>
      </div>

      <Dialog open={openConfirmDialog} onClose={handleCancel} dir="rtl">
        <DialogTitle style={{ textAlign: 'right' }}>{chapterHasQuestions ? "תחילת הפרק" : "המשך"}</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ textAlign: 'right' }}>
            {messageBeforeChapter || (
              chapterHasQuestions ? "האם את/ה בטוח/ה שברצונך להתחיל את הפרק?" : "האם את/ה בטוח/ה שברצונך להמשיך?"
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'flex-start' }}>
          <Button onClick={handleCancel} color="secondary">
            ביטול
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            {chapterHasQuestions ? "התחל" : "המשך"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openSkipDialog} onClose={handleCancel} dir="rtl">
        <DialogTitle style={{ textAlign: 'right' }}>דלג על ההפסקה</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ textAlign: 'right' }}>
            האם את/ה בטוח/ה שברצונך לדלג על ההפסקה?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'flex-start' }}>
          <Button onClick={handleCancel} color="secondary">
            ביטול
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            דלג
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
